import Callout from "../../../../components/Callout/Callout";

export default function InfoText() {
    return (
        <Callout>
            Sva unesena iskustva su anonimnog karaktera, osim ako ste{" "}
            <a
                href="https://www.youtube.com/watch?v=glZEVkBQzYM&t=86s"
                target="_blank"
                className="underline"
            >
                Đuro...
            </a>
            <br /> Podaci iz korisničkog naloga se ne koriste niti su u bilo
            kojem obliku dostupne kompaniji.
            <br /> Vaša privatnost je zagarantovana.
        </Callout>
    );
}
